/* Careatic Collection Lookbook — vertical scroll → horizontal breed runway.
   Desktop only; mobile / reduced-motion fall back to the stacked CSS layout. */
(function () {
  'use strict';

  function initMobile(root) {
    if (root.dataset.lbMobile) return;
    root.dataset.lbMobile = '1';
    var film = root.querySelector('[data-lb-film]');
    var looks = Array.prototype.slice.call(root.querySelectorAll('[data-lb-look]'));
    var rails = Array.prototype.slice.call(root.querySelectorAll('[data-lb-rail]'));
    if (!film || !looks.length) return;
    var active = -1, ticking = false;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ca-lb__dots';
    dotsWrap.setAttribute('aria-hidden', 'true');
    var dots = [];
    for (var n = 0; n < looks.length; n++) {
      var dot = document.createElement('span');
      dot.className = 'ca-lb__dot';
      (function (idx) { dot.addEventListener('click', function () { looks[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }); })(n);
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
    film.insertAdjacentElement('afterend', dotsWrap);

    function setActive(k) {
      if (k === active) return;
      active = k;
      for (var i = 0; i < looks.length; i++) looks[i].classList.toggle('is-current', i === k);
      for (var j = 0; j < rails.length; j++) rails[j].classList.toggle('is-active', j === k);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === k);
    }
    function upd() {
      ticking = false;
      var c = film.scrollLeft + film.clientWidth / 2;     // viewport centre within the slider
      var best = 0, bestd = Infinity;
      for (var i = 0; i < looks.length; i++) {
        var mid = looks[i].offsetLeft + looks[i].offsetWidth / 2;
        var d = Math.abs(mid - c);
        if (d < bestd) { bestd = d; best = i; }
      }
      setActive(best);
    }
    film.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function init(root) {
    if (root.dataset.lbReady) return;
    var desktop = window.matchMedia('(min-width: 1024px)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!desktop) { initMobile(root); return; }
    if (reduce) { root.classList.add('ca-lb--flat'); return; }
    root.dataset.lbReady = '1';

    var looks = Array.prototype.slice.call(root.querySelectorAll('[data-lb-look]'));
    var rails = Array.prototype.slice.call(root.querySelectorAll('[data-lb-rail]'));
    var stage = root.querySelector('.ca-lb__stage');
    var numEl = root.querySelector('[data-lb-num]');
    var bar = root.querySelector('[data-lb-bar]');
    var N = looks.length;
    if (N === 0) return;

    var STEP = window.innerWidth * 0.30; // horizontal gap between adjacent looks
    var active = -1;
    var ticking = false;
    var px = 0, py = 0;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

    function render() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var travel = root.offsetHeight - stage.offsetHeight;
      var p = clamp(-rect.top / (travel || 1), 0, 1);
      var f = p * (N - 1);              // active position as a float 0..N-1
      var cur = clamp(Math.round(f), 0, N - 1);

      for (var i = 0; i < N; i++) {
        var d = i - f;                  // signed distance from the active look
        var ad = Math.abs(d);
        var x = d * STEP;
        var scale = clamp(1 - ad * 0.14, 0.62, 1);
        var blur = Math.min(ad * 3.5, 8);
        var op = clamp(1 - ad * 0.4, 0.12, 1);
        var s = looks[i].style;
        var tf = 'translate(-50%, -50%) translateX(' + x.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
        if (i === cur) { tf += ' rotateY(' + (px * 5).toFixed(2) + 'deg) rotateX(' + (-py * 4).toFixed(2) + 'deg) translateZ(40px)'; }
        s.transform = tf;
        s.filter = blur > 0.2 ? 'blur(' + blur.toFixed(1) + 'px)' : 'none';
        s.opacity = op.toFixed(3);
        s.zIndex = Math.round(50 - ad * 10);
      }

      if (cur !== active) {
        active = cur;
        if (numEl) numEl.textContent = pad(cur + 1);
        for (var r = 0; r < rails.length; r++) rails[r].classList.toggle('is-active', r === cur);
      }
      if (bar) bar.style.width = (14 + p * 60).toFixed(0) + 'px';
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(render); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { STEP = window.innerWidth * 0.30; onScroll(); });
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      px = ((e.clientX - r.left) / r.width - 0.5) * 2;
      py = ((e.clientY - r.top) / r.height - 0.5) * 2;
      root.style.setProperty('--lb-px', px.toFixed(3));
      root.style.setProperty('--lb-py', py.toFixed(3));
      onScroll();
    });
    stage.addEventListener('mouseleave', function () {
      px = 0; py = 0;
      root.style.setProperty('--lb-px', '0');
      root.style.setProperty('--lb-py', '0');
      onScroll();
    });
    render();
  }

  function boot() {
    document.querySelectorAll('[data-ca-lookbook]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-init inside the Shopify theme editor
  document.addEventListener('shopify:section:load', boot);
})();
